import { useWindowSize } from 'usehooks-ts'
import { calculateDeviceInfo } from 'utils/calculate-device-info'

export const useDeviceInfo = () => {
  const { width } = useWindowSize()
  return calculateDeviceInfo(width)
}
